import React, { Component } from "react";
import PropTypes from 'prop-types';
import classnames from 'classnames';

import "./TemplateListItem.scss";

class TemplateItem extends Component { 
  static propTypes = {
    template: PropTypes.object.isRequired,
    onClickTemplate: PropTypes.func.isRequired,
  };

  /*
  onClickTemplateItem = id => {
    const { onClickTemplate } = this.props;
    onClickTemplate(id);
  }
  */

  render() {
    const { template, onClickTemplate } = this.props;

    const templateClass = classnames({
      'template-wrap': true,
      'default': template.is_default,
      'hidden': !template.is_enabled,
    });

    const srcPreview = (template && template.thumbnail && template.thumbnail.url) ? template.thumbnail.url : null;
    const bgStyle = {
      backgroundImage:` url(${srcPreview})`,
      backgroundSize: 'cover',
    };

    return (
      <div className={templateClass} onClick={() => onClickTemplate(template.id)}>

        <div className="template-image-wrap">
          <div className="template-image" style={bgStyle}>
            {template.is_default ? (<div className="template-label">По умолчанию</div>) : false}
            {!template.is_enabled ? (<div className="template-label">Скрыто</div>) : false}
          </div>
        </div>
        <div className="template-title">{template.name}</div>
      </div>
    );
  }
}

export default TemplateItem;
